import { Link } from "react-router-dom";
import logo from "../assets/logowhite.png";

function PhoneIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width={16}
      height={16}
      {...props}
    >
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
  );
}

function FacebookIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      width={18}
      height={18}
      {...props}
    >
      <path d="M22 12.06C22 6.51 17.52 2 12 2S2 6.51 2 12.06C2 17.06 5.66 21.2 10.44 21.95V14.9H7.9v-2.84h2.54v-2.17c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56v1.84h2.77l-.44 2.84h-2.33v7.05C18.34 21.2 22 17.06 22 12.06z" />
    </svg>
  );
}

function InstagramIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width={18}
      height={18}
      {...props}
    >
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
      <path d="M16 11.37a4 4 0 1 1-7.914 1.174A4 4 0 0 1 16 11.37z" />
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
    </svg>
  );
}

function XIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      width={16}
      height={16}
      {...props}
    >
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}

export default function Footer() {
  return (
    <footer className="footer">
      <div className="wrap">
        <div className="footer__grid">
          <div>
            {/* <div className="footer__logo">ChachoPhone</div> */}
            <Link to="/" className="logo" aria-label="ChachoPhone, inicio">
              <img src={logo} alt="" height={70} />
            </Link>
            <p style={{ fontSize: "0.92rem", maxWidth: "34ch" }}>
              Móviles libres, con garantía oficial y entrega en toda Canarias. Sin letra pequeña.
            </p>
            <p
              style={{
                fontSize: "0.92rem",
                maxWidth: "34ch",
                marginTop: 10,
                display: "flex",
                alignItems: "center",
                gap: 6,
              }}
            >
              <PhoneIcon />
              <a href="tel:+34822263668" style={{ color: "inherit" }}>
                +34 822 26 36 68
              </a>
            </p>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 14,
                marginTop: 12,
              }}
            >
              <a
                href="https://facebook.com/chachophone"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                style={{ color: "inherit" }}
              >
                <FacebookIcon />
              </a>
              
              <a
                href="https://www.instagram.com/chacho.phone"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                style={{ color: "inherit" }}
              >
                <InstagramIcon />
              </a>
              
              <a
                href="https://x.com/chachophone"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="X (Twitter)"
                style={{ color: "inherit" }}
              >
                <XIcon />
              </a>
            </div>
          </div>

          <div>
            <h4>Comprar</h4>
            <ul>
              <li><Link to="/moviles">Todos los móviles</Link></li>
              <li><Link to="/moviles?sort=price_asc">Más baratos</Link></li>
              <li><Link to="/moviles?brand=Samsung">Samsung</Link></li>
              <li><Link to="/moviles?brand=Xiaomi">Xiaomi</Link></li>
            </ul>
          </div>

          <div>
            <h4>Ayuda</h4>
            <ul>
              <li><Link to="/carrito">Mi carrito</Link></li>
              <li><a href="mailto:hola@chachophone.com">Escríbenos</a></li>
              <li><Link to="/moviles">Estado del pedido</Link></li>
            </ul>
          </div>

          <div>
            <h4>Legal</h4>
            <ul>
              <li><Link to="/privacidad">Política de Privacidad</Link></li>
              <li><Link to="/proteccion-datos">Política de Cookies</Link></li>
              <li><Link to="/aviso-legal">Aviso legal</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer__base">
          <span>© {new Date().getFullYear()} ChachoPhone</span>
          <span>Precios con IVA incluido</span>
        </div>
      </div>
    </footer>
  );
}